import AbstractTool from "../AbstractTool";

export default class EraseTool extends AbstractTool {
    scrollEnabled = true;
    resetPreviousTool = true;

    activate() {
        super.activate();
        this.elements.hovered()
            ? this.cursor.delete()
            : this.cursor.arrow();
    }

    deactivate() {
        super.deactivate();
    }

    clickMouseOnCanvas() {
        let hover = this.elements.hovered();
        if (hover) {
            this.elements.delete([hover]);
            this.cursor.arrow();
        }
    }

    moveMouse() {
        let hovered = this.elements.hovered();
        hovered
            ? this.cursor.delete()
            : this.cursor.arrow();
        this.hoverSet.set(hovered);
    }

    getTips() {
        return "Click on an element to delete it. Right click to select element when they overlap."
    }

    pressKey(code) {
        switch (code) {
            case 27: // Esc
                this.setTool('select');
                break;
            case 37: // left arrow
                this.view.move(this.arrowMove, 0);
                break;
            case 38: // up arrow
                this.view.move(0, this.arrowMove);
                break;
            case 39: // right arrow
                this.view.move(-this.arrowMove, 0);
                break;
            case 40: // down arrow
                this.view.move(0, -this.arrowMove);
                break;
        }
    }
}
